export const state = () => ({
  articles: [],
  articlesLoading: true
})
export const getters = {
  articles(state) {
    return state.articles
  },
  articlesLoading(state) {
    return state.articlesLoading
  }
}
export const mutations = {
  setArticles(state, { data }) {
    state.articles = data
    state.articlesLoading = false
  },
  setArticlesLoading(state, { data }) {
    state.articlesLoading = data
  }
}
export const actions = {
  getArticles({ commit, rootState }, { recoStorage, currentArticle }) {
    commit('setArticlesLoading', { data: true })
    return this.$axios
      .post(`/api/recommendation/articles/${rootState.language}`, {
        recoStorage: recoStorage[rootState.language],
        currentArticle
      })
      .then((res) => {
        commit('setArticles', { data: res.data })
      })
      .catch((err) => {
        commit('setArticles', { data: [] })
        console.error(err)
      })
  }
}
